import { render } from "./ReportActivationRatioTd.vue?vue&type=template&id=11bcaf74"
import script from "./ReportActivationRatioTd.vue?vue&type=script&lang=js"
export * from "./ReportActivationRatioTd.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__